<template>
    <!-- 我的团队 -->
    <div id="myTeam">
        <div v-if="!transferPrestoreVisible && !editTeamInfoVisible">
            <el-card shadow="never" class="myTeam_card">
                <div slot="header" class="clearfix">
                    <div class="desciconLarge"></div>
                    <span class="font18">{{ info.title }}</span>
                </div>
                <el-card class="box-card">
                    <div slot="header" class="team_card_header">
                        <span style="margin-left: 20px; font-weight: 500">{{ teamForm.teamName }}</span>
                        <!-- <el-button v-if="teamForm.clientCharacterRole != 1" class="team_card_right" type="text" @click="logoutTeam()" >退出团队</el-button> -->
                        <el-button v-if="teamForm.clientCharacterRole == 1" class="team_card_right" style="color: #ff0000" type="text" @click="dissolveTeamQ()">解散团队</el-button>
                        <el-button v-if="teamForm.clientCharacterRole == 1" class="team_card_right" type="text" @click="editTeam()">编辑团队信息</el-button>
                    </div>
                    <div class="myteam_info">
                        <div class="myteam_info_img">
                            <el-image :src="imgUrl" class="team_img">
                                <div slot="error">
                                    <img src="@/assets/img/avatarTeam.png" class="team_img" />
                                </div>
                            </el-image>
                        </div>
                        <el-descriptions :colon="false" :column="2">
                            <el-descriptions-item label="团长" v-if="userInfo.characterRole === 1 || userInfo.characterRole === 2">{{ teamForm.teamHeadName }}</el-descriptions-item>
                            <el-descriptions-item label="团长" :span="4" v-else>{{ teamForm.teamHeadName }}</el-descriptions-item>
                            <el-descriptions-item label="团长手机号">{{ teamForm.teamHeadPhone }}</el-descriptions-item>
                            <!-- <el-descriptions-item label="团队预存余额" :span="2"  v-show="userInfo.characterRole === 1 || userInfo.characterRole === 2">
              <span
                class="redColor"
              >¥{{teamForm.depositAdvance ? teamForm.depositAdvance.toFixed(2): '0.00'}}</span>
              <el-button  type="text" v-if="teamForm.clientCharacterRole == 1" @click="transferHandle()" class="descBtn descBtnone">预存划拨</el-button>
              <el-button type="text" v-if="teamForm.clientCharacterRole == 1" @click="applyPrestore()" class="descBtn">预存有礼</el-button>
            </el-descriptions-item> -->

                            <!-- <el-descriptions-item label="团队信用欠款" :span="2">
              <div  style=" position: relative;">
                <span class="redColor">¥{{teamForm.toBePaidDebt ? teamForm.toBePaidDebt.toFixed(2): '0.00'}}</span>
              <div class="apply">团队信用总额：¥{{teamForm.lineCredit ? teamForm.lineCredit.toFixed(2): '0.00'}}</div>
              </div>
            </el-descriptions-item> -->
                            <!-- <el-descriptions-item label="团队赠送金余额">¥{{teamForm.cashCouponBalance ? teamForm.cashCouponBalance.toFixed(2): '0.00'}}</el-descriptions-item> -->
                            <!-- <el-descriptions-item label="团队欠款总额" :span="2"><span class="redColor">¥{{teamForm.debtMoneyTeam ? teamForm.debtMoneyTeam.toFixed(2): '0.00'}}</span></el-descriptions-item> -->
                            <el-descriptions-item label="团员人数">{{ teamForm.personnelNum ? teamForm.personnelNum : 0 }}人</el-descriptions-item>
                            <el-descriptions-item label="团队订单" :span="2">
                                <div class="descItem">
                                    {{ orderTeamNumber ? orderTeamNumber : 0 }}
                                    <!-- <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="teamForm.paymentAudit == 1 ? '团队成员使用团队预存或信用值下单后需管理员或团长审核': '团队成员使用团队预存或信用值下单无需审核'" placement="top">
                                        <i style="color:#E6A23C;font-size: 17px;cursor: pointer;margin-bottom: 2px" class="el-icon-warning"></i>
                                    </el-tooltip> -->
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item :labelStyle="{width: '0px'}">
                                <div style="width: 300px">
                                  <i style="color: #f0a74a" class="el-icon-warning">{{teamForm.paymentAudit == 1 ? '已开启团队支付审核' : '已关闭团队支付审核'}}</i>
                                  <!-- <el-alert :title="teamForm.paymentAudit == 1 ? '已开启支付审核' : '已关闭支付审核'" type="warning" :closable="false" show-icon></el-alert> -->
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-card>
                <div class="inviteWay">
                    <div class="desciconLarge"></div>
                    <span class="font18">邀请方式</span>
                    <el-row :gutter="40" type="flex" style="flex-wrap: wrap">
                        <el-col :span="8">
                            <div class="invite_card">
                                <div class="invite_card_left">
                                    <h3 class="invite_title">海报邀请</h3>
                                    <div class="font14666">邀请方式：分享您的专属邀请图，好友长按图片—识别图中二维码—注册</div>
                                </div>
                                <div class="invite_card_right">
                                    <img style="invite_img" src="../../assets/img/report.png" />
                                    <div class="invite_right_button" @click="lookPoster">查看海报</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="invite_card">
                                <div class="invite_card_left">
                                    <h3 class="invite_title">小程序邀请</h3>
                                    <div class="font14666">邀请方式：微信小程序搜索“纳微创新”，通过“个人>邀请返利”分享给您的好友</div>
                                </div>
                                <div class="invite_card_right">
                                    <img style="invite_img" src="../../assets/img/code.png" />
                                    <div>
                                        <el-popover placement="bottom-end" width="350" trigger="click">
                                            <div class="codeBox">
                                                <div>
                                                    <img style="width: 150px;" :src="QrCode" />
                                                </div>
                                                <div>
                                                    使用微信扫码进入
                                                    <br />
                                                    点击右上角分享好友
                                                    <br />
                                                    完成注册即可确认邀请成功
                                                    <div class="invite_right_button" style="width: 100px" @click="dowloadImg">下载小程序码</div>
                                                </div>
                                            </div>
                                            <el-button slot="reference" class="invite_right_button">查看二维码</el-button>
                                        </el-popover>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
            <el-card style="margin: 30px 0" shadow="never" v-if="teamForm.clientCharacterRole != 3">
                <div slot="header">
                    <div class="desciconLarge"></div>
                    <span class="font18">订单支付审核</span>
                </div>
                <el-tabs v-model="activeName" type="card" size="small" @tab-click="handleClick">
                    <el-tab-pane name="first">
                        <template slot="label">
                            <el-badge v-if="orderCheckTotal > 0 && teamForm.clientCharacterRole != 3" :value="orderCheckTotal" class="item">
                                <span>待审核</span>
                            </el-badge>
                            <span v-else>待审核</span>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane label="已审核" name="second"></el-tab-pane>
                </el-tabs>
                <el-table :data="orderData" style="width: 100%" :header-cell-style="{ background: '#F5F5F5' }">
                    <el-table-column prop="equipmentName" align="center" label="实验名称">
                        <template slot-scope="scope">
                            <span class="clickName" @click="toOrderList(scope.row)">{{ scope.row.equipmentName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalCost" align="center" label="实付款">
                        <template slot-scope="scope">¥{{ scope.row.totalCost || '0.00' }}</template>
                    </el-table-column>
                    <el-table-column prop="clientName" align="center" label="下单人"></el-table-column>
                    <el-table-column prop="prepaidPayment" align="center" label="支付方式">
                        <template slot-scope="scope">{{ dictFilter(scope.row.prepaidPayment ? scope.row.prepaidPayment.toString() : '-', 'prepaidPayment') }}</template>
                    </el-table-column>
                    <el-table-column prop="orderDate" align="center" label="申请时间">
                        <template slot-scope="scope">{{ moment(scope.row.orderDate).format('yyyy-MM-DD HH:mm') }}</template>
                    </el-table-column>
                    <el-table-column prop="checkName" align="center" label="审核人" v-if="activeName == 'second'"></el-table-column>
                    <el-table-column prop="checkStatus" align="center" label="审核结果" v-if="activeName == 'second'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.checkStatus == 2" style="color: #67c23a">通过</span>
                            <span v-if="scope.row.checkStatus == 3" style="color: #ff543a">拒绝</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" align="center" v-if="teamForm.clientCharacterRole != 3 && activeName == 'first'">
                        <template slot-scope="scope">
                            <el-button type="text" @click="orderCheckHandle(scope.row, 2)">同意</el-button>
                            <el-button type="text" style="color: #ff543a" @click="orderCheckHandle(scope.row, 3)">拒绝</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" align="center" v-if="activeName == 'second'">
                        <template slot-scope="scope">
                            <el-button type="text" @click="checkRemark(scope.row)">查看备注</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    style="float: right; margin: 10px 0"
                    @size-change="handleSizeOrderChange"
                    @current-change="handleCurrentOrderChange"
                    :current-page.sync="orderpageNum"
                    :page-size="orderpageSize"
                    layout="total, prev, pager, next"
                    :total="orderTotal"></el-pagination>
            </el-card>
            <el-card shadow="never" v-if="teamForm.clientCharacterRole != 3">
                <div slot="header">
                    <div class="desciconLarge"></div>
                    <span class="font18">入团申请</span>
                </div>
                <el-table :data="tableData1" style="width: 100%" :header-cell-style="{ background: '#F5F5F5' }">
                    <el-table-column prop="clientName" align="center" label="姓名"></el-table-column>
                    <el-table-column prop="realNameStatus" align="center" label="是否实名">
                        <template slot-scope="scope">{{ scope.row.realNameStatus == 0 ? '否' : '是' }}</template>
                    </el-table-column>
                    <el-table-column prop="phoneNumber" align="center" label="联系电话"></el-table-column>
                    <el-table-column prop="applyDate" align="center" label="申请时间"></el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="checkJoinTeam(scope.row, 2)">同意</el-button>
                            <el-button type="text" style="color: #ff543a" @click="checkJoinTeam(scope.row, 3)">拒绝</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    style="float: right; margin: 10px 0"
                    @size-change="handleSizeCheckChange"
                    @current-change="handleCurrentCheckChange"
                    :current-page.sync="checkpageNum"
                    :page-size="checkpageSize"
                    layout="total, prev, pager, next"
                    :total="checkTotal"></el-pagination>
            </el-card>
            <el-card style="margin: 30px 0" shadow="never">
                <div slot="header">
                    <div class="desciconLarge"></div>
                    <span class="font18">团队成员</span>
                </div>
                <el-table :data="tableData" id="tableButton" style="width: 100%" :header-cell-style="{ background: '#F5F5F5' }">
                    <el-table-column prop="clientName" align="center" label="姓名"></el-table-column>
                    <el-table-column prop="applyDate" align="center" label="入团时间"></el-table-column>
                    <el-table-column prop="realNameStatus" align="center" label="是否实名">
                        <template slot-scope="scope">{{ scope.row.realNameStatus == 0 ? '否' : '是' }}</template>
                    </el-table-column>
                    <el-table-column prop="phoneNumber" align="center" label="联系电话"></el-table-column>
                    <el-table-column prop="roleName" align="center" label="角色">
                        <template slot-scope="scope">{{ dictFilter(scope.row.characterRole ? scope.row.characterRole.toString() : '-', 'characterRole') }}</template>
                    </el-table-column>
                    <el-table-column prop="teamCompleteOrderNumber" align="center" label="完成订单"></el-table-column>
                    <el-table-column prop="teamOrderTotalCost" align="center" label="订单金额" v-if="userInfo.characterRole !== 3"></el-table-column>
                    <el-table-column prop="teamDebtTotalCost" align="center" label="团队欠款金额" v-if="userInfo.characterRole !== 3"></el-table-column>
                    <el-table-column prop="toBePaidDebt" align="center" label="个人欠款金额" v-if="userInfo.characterRole !== 3"></el-table-column>
                    <el-table-column v-if="teamForm.paymentAudit == 1 && userInfo.characterRole != 3" label="免审核额度" width="180" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.edit">
                                <input type="number" style="width: 70px; text-align: center;" v-model="scope.row.teamAuditFlag_new">
                                <el-button style="margin-left: 10px;" type="text" size="small" @click="setTeamAuditFlag(scope.row, scope.$index)">确认</el-button>
                            </div>
                            <div v-else>
                                <span>{{ scope.row.teamAuditFlag_new }}</span>
                                <el-button style="margin-left: 10px;" type="text" size="small" @click="scope.row.edit = true">编辑</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" v-if="teamForm.clientCharacterRole == 1 && scope.row.characterRole != 1" @click="transferTeam(scope.row)">转让团长</el-button>
                            <el-button type="text" size="small" style="color: #ff543a" v-if="teamForm.clientCharacterRole != 3 && scope.row.characterRole != 1" @click="removeTeam(scope.row)">移出团队</el-button>
                            <el-button type="text" size="small" v-if="teamForm.clientCharacterRole == 1 && scope.row.characterRole == 3" @click="setRole(scope.row)">设为管理员</el-button>
                            <el-button type="text" size="small" v-if="teamForm.clientCharacterRole == 1 && scope.row.characterRole == 2" @click="cancelRole(scope.row)">取消管理员</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    style="float: right; margin: 10px 0"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrenChange"
                    :current-page.sync="pageNum"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total"></el-pagination>
            </el-card>
        </div>
        <div>
            <!-- 预存划拨 -->
            <prestoreTransfer v-if="transferPrestoreVisible" ref="prestoreTransfer" @back="closeInvoice"></prestoreTransfer>
            <!-- 邀请好友海报 -->
            <posterView ref="poster" v-if="posterVisible"></posterView>
            <!-- 设置/取消管理员 -->
            <setRole ref="setRole" v-if="setRoleVisible" @back="closeInvoice()"></setRole>
            <!-- 编辑团队 -->
            <editTeamInfo ref="editTeamInfo" :info="{ title: '编辑团队信息' }" v-if="editTeamInfoVisible" @back="closeInvoice()"></editTeamInfo>
            <!-- 订单审核 -->
            <orderCheck ref="orderCheck" v-if="orderCheckVisible" @back="getOrderList(teamForm.teamId)"></orderCheck>
            <!-- 提示框 -->
            <tipsDialog ref="tipsDialog" v-if="tipsDialogVisible"></tipsDialog>
            <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="toCreateTeam">
                <span>您的团队已解散，我们为您保存了个人账号，后期您仍可以继续在平台预约检测，感谢您对我们的支持</span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="toCreateTeam">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { teamInfo, joinTeamList, checkJoinTeam, joinTeamCheckList, removeTeam, transferTeam, dissolveTeam, controlTeamAuditFlag, inviteTeamFriends, checkTeamList } from '@/api/request';
import { getClient } from '@/plugins/auth';
import prestoreTransfer from './formPop/prestoreTransfer';
import posterView from './formPop/posterView';
import setRole from './formPop/setRole';
import editTeamInfo from './createTeam';
import orderCheck from './formPop/orderCheck';
import tipsDialog from './formPop/tipsDialog';
import moment from 'moment';
export default {
    props: {
        info: {
            type: [Object, Array],
            default: () => {}
        }
    },
    components: { prestoreTransfer, posterView, setRole, editTeamInfo, orderCheck, tipsDialog },
    data() {
        return {
            moment,
            QrCode: '',
            activeName: 'first',
            posterVisible: false,
            dialogVisible: false,
            teamForm: {},
            imgUrl: '',
            fileUrl: process.env.VUE_APP_FILE_API,
            transferPrestoreVisible: false,
            editTeamInfoVisible: false,
            setRoleVisible: false,
            orderCheckVisible: false,
            tipsDialogVisible: false,
            tableData: [],
            tableData1: [],
            orderData: [],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            checkpageNum: 1,
            checkpageSize: 10,
            checkTotal: 0,
            orderpageNum: 1,
            orderpageSize: 10,
            orderTotal: 0,
            orderCheckTotal: 0,
            queryType: 15,
            userInfo: {},
            orderTeamNumber: 0,//团队订单总数
        };
    },
    watch: {
        // 本来是用getClient(),但是创建团队后当前页面获取不到最新的teamId
        '$store.getters.userInfo.teamId': {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.getTeamInfo(newVal);
                }
            }
        }
    },
    created() {
        this.userInfo = this.$store.getters.userInfo;
    },
    mounted() {
        this.getQrCode();
        if (this.$store.getters.userInfo.teamId) {
            this.getTeamInfo(this.$store.getters.userInfo.teamId);
        }
    },
    methods: {
        //获取团队详情
        getTeamInfo(teamId) {
            teamInfo(teamId).then((res) => {
                this.teamForm = res.data;
                this.imgUrl = process.env.VUE_APP_FILE_API + res.data.teamProFilePhoto;
                this.getJoinTeamList(teamId);
                this.getjoinTeamCheckList(teamId);
                this.getOrderList(teamId);
                this.userInfo = JSON.parse(getClient());
                this.orderTeamNumber = res.data.teamUnComplteteNumbers + res.data.teamComplteteNumbers
                this.$forceUpdate();
            });
        },
        //获取团队成员列表
        getJoinTeamList(teamId) {
            joinTeamList({
                teamId: teamId,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then((res) => {
                res.rows.forEach(item => {
                    item.edit = false
                    item.teamAuditFlag_new = item.teamAuditFlag >= this.teamForm.freePay ? item.teamAuditFlag : this.teamForm.freePay
                })
                this.tableData = res.rows;
                this.total = res.total;
            });
        },
        handleClick(tab, event) {
            this.orderData = [];
            if (tab.name == 'first') {
                this.queryType = 15;
            } else {
                this.queryType = 16;
            }
            this.getOrderList(this.teamForm.teamId);
        },
        toOrderList(row) {
            this.$router.push({ query: { type: 13, tabIndex: '4-4', tabName: '团队订单', orderCode: row.orderCode } }).catch(() => {});
        },
        getOrderList(teamId) {
            checkTeamList({
                teamId: teamId,
                queryType: this.queryType,
                pagesize: this.orderpageSize,
                pageNum: this.orderpageNum,
            }).then((res) => {
                this.orderData = res.rows;
                this.orderTotal = res.total;
                if (this.activeName == 'first') {
                    this.orderCheckTotal = res.total;
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getJoinTeamList(this.teamForm.teamId);
        },
        handleCurrenChange(val) {
            this.pageNum = val;
            this.getJoinTeamList(this.teamForm.teamId);
        },
        handleSizeCheckChange(val) {
            this.checkpageSize = val;
            this.getjoinTeamCheckList(this.teamForm.teamId);
        },
        handleCurrentCheckChange(val) {
            this.checkpageNum = val;
            this.getjoinTeamCheckList(this.teamForm.teamId);
        },
        handleSizeOrderChange(val) {
            this.orderpageSize = val;
            this.getOrderList(this.teamForm.teamId)
        },
        handleCurrentOrderChange(val) {
            this.orderpageNum = val;
            this.getOrderList(this.teamForm.teamId)
        },
        //获取入团申请列表
        getjoinTeamCheckList(teamId) {
            joinTeamCheckList({
                teamId: teamId,
                pageNum: this.checkpageNum,
                pageSize: this.checkpageSize
            }).then((res) => {
                this.tableData1 = res.rows;
                this.checkTotal = res.total;
            });
        },
        //查看海报
        lookPoster() {
            this.posterVisible = true;
            this.$nextTick(() => {
                this.$refs.poster.init(2);
            });
        },
        //下载小程序码
        dowloadImg() {
            let nowTime = moment().format('yyyy-MM-DD');
            const filename = `邀请好友-小程序码${nowTime}`;
            const img = document.createElement('a');
            img.href = this.QrCode;
            img.download = filename;
            img.click();
        },
        //获取二维码
        getQrCode() {
            inviteTeamFriends({ width: 100, page: 'pages_my/team/teamGuide', teamId: this.teamForm.teamId }).then((res) => {
                let byteData = res.qrCodeBytes;
                // 创建图像的 URL
                this.QrCode = 'data:image/png;base64,' + byteData;
            });
        },
        closeInvoice() {
            this.transferPrestoreVisible = false;
            this.editTeamInfoVisible = false;
            this.getTeamInfo(this.teamForm.teamId);
            this.getjoinTeamCheckList(this.teamForm.teamId);
            this.getJoinTeamList(this.teamForm.teamId);
        },
        //预存划拨
        transferHandle() {
            this.transferPrestoreVisible = true;
            this.$nextTick(() => {
                this.$refs.prestoreTransfer.init();
            });
        },

        //移出团队
        removeTeam(row) {
            this.$confirm('是否确认移出该成员?', '确认', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    removeTeam({ clientId: row.clientId }).then((res) => {
                        this.$message.success('操作成功');
                        this.getJoinTeamList(this.teamForm.teamId);
                    });
                })
                .catch(() => {});
        },
        editTeam() {
            this.editTeamInfoVisible = true;
        },
        dissolveTeamQ() {
            this.$confirm('是否确认解散该团队?', '确认', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    dissolveTeam().then((res) => {
                        this.$message.success('解散成功');
                        this.dialogVisible = true;
                    });
                })
                .catch(() => {});
        },
        toCreateTeam() {
            this.dialogVisible = false;
            this.$store
                .dispatch('GetInfo')
                .then(() => {})
                .catch((err) => {});
            this.$emit('selectSubName', { index: '4-1', title: '加入团队' });
        },
        //退出团队
        logoutTeam() {
            this.$confirm('是否确认退出该团队?', '确认', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    removeTeam({ clientId: this.userInfo.clientId }).then((res) => {
                        this.$message.success('退出成功');
                        this.$store
                            .dispatch('GetInfo')
                            .then(() => {})
                            .catch((err) => {});
                        this.$emit('selectSubName', { index: '4-1', title: '加入团队' });
                    });
                })
                .catch(() => {});
        },
        //订单审核
        orderCheckHandle(row, type) {
            this.orderCheckVisible = true;
            this.$nextTick(() => {
                let obj = {
                    typeValue: type == 2 ? '审核通过' : '审核拒绝',
                    type: type,
                    tips: '审核通过后将扣减对应余额以及订单中使用的赠送金和优惠券'
                };
                this.$refs.orderCheck.init(row, obj);
            });
        },
        //查看备注
        checkRemark(row) {
            if (!row.checkRemark || row.checkRemark == '') {
                return this.$message.error('审核人未填写审核备注');
            }
            this.tipsDialogVisible = true;
            this.$nextTick(() => {
                let obj = {
                    title: '订单审核备注',
                    tips: '审核备注：',
                    width: '500px'
                };
                this.$refs.tipsDialog.init(row, obj);
            });
        },
        //设为管理员
        setRole(row) {
            this.setRoleVisible = true;
            this.$nextTick(() => {
                let obj = {
                    title: '设为管理员',
                    content: '确定修改角色为管理员吗？',
                    width: '690px',
                    tips: '管理员权限：1、审核团队成员使用团队信用值支付的订单。2、索取使用团队信用值支付的订单发票'
                };
                this.$refs.setRole.init(row, obj);
            });
        },
        //取消管理员
        cancelRole(row) {
            this.setRoleVisible = true;
            this.$nextTick(() => {
                let obj = {
                    title: '取消管理员',
                    content: '确定修改角色为团员吗？',
                    width: '550px'
                };
                this.$refs.setRole.init(row, obj);
            });
        },
        //转让团长
        transferTeam(row) {
            this.$confirm('是否确认将团长转移出去?', '确认', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    //转移的时候后端要求传转移人的手机号邮箱电话
                    transferTeam({
                        teamId: this.teamForm.teamId,
                        teamHeadId: row.clientId,
                        teamHeadName: row.clientName,
                        teamHeadPhone: row.phoneNumber,
                        teamHeadEmail: row.email
                    }).then((res) => {
                        this.$message.success('转移成功');
                        // 转移之后需要刷新团队信息和登录信息，上面有根据这两个作为条件判断
                        this.$store
                            .dispatch('GetInfo')
                            .then(() => {})
                            .catch((err) => {});
                        this.getTeamInfo(this.teamForm.teamId);
                        this.getJoinTeamList(this.teamForm.teamId);
                    });
                })
                .catch(() => {});
        },
        // 申请审核
        checkJoinTeam(row, type) {
            let msg = type == 2 ? '确认是否同意该申请?' : '确认是否拒绝该申请?';
            this.$confirm(msg, '确认', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                checkJoinTeam({
                    teamId: this.teamForm.teamId,
                    clientId: row.clientId,
                    checkValue: type
                }).then((res) => {
                    this.$message.success('操作成功');
                    this.getjoinTeamCheckList(this.teamForm.teamId);
                    this.getJoinTeamList(this.teamForm.teamId);
                });
            })
            .catch(() => {});
        },
        //修改特定人员免审核额度
        setTeamAuditFlag(row, index) {
            if(row.teamAuditFlag_new < this.teamForm.freePay) {
                this.$message.error('个人免审核金额不能小于团队免审核金额')
				this.tableData[index].teamAuditFlag_new = this.tableData[index].teamAuditFlag >= this.teamForm.freePay ? this.tableData[index].teamAuditFlag : this.teamForm.freePay
				return
			}
			if(row.teamAuditFlag_new > 10000) {
                this.$message.error('免审核金额为1-10000元')
				this.tableData[index].teamAuditFlag_new = this.tableData[index].teamAuditFlag >= this.teamForm.freePay ? this.tableData[index].teamAuditFlag : this.teamForm.freePay
				return
			}
			const data = {
				clientId: row.clientId,
				teamAuditFlag: Number(row.teamAuditFlag_new),
			}
            controlTeamAuditFlag(data).then(res => {
				this.$message.success('修改成功！')
                this.tableData[index].edit = false
			}).catch(err => {
				this.tableData[index].teamAuditFlag_new = this.tableData[index].teamAuditFlag >= this.teamForm.freePay ? this.tableData[index].teamAuditFlag : this.teamForm.freePay
                this.tableData[index].edit = false
		    })
        }
    }
};
</script>
<style>
#tableButton .el-button {
    padding: 0;
}
.box-card .el-card__header {
    padding: 0;
    height: 50px;
    line-height: 50px;
}
.myTeam_card .el-descriptions-item__label:not(.is-bordered-label) {
    width: 110px;
    color: #111;
    font-size: 14px;
    font-weight: 500;
}
.myTeam_card .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding-bottom: 30px;
}
#myTeam .el-tabs__item {
    font-size: 15px;
    padding: 0 30px;
}
#myTeam .el-badge__content.is-fixed {
    top: 10px;
    right: 0;
}
</style>
<style scoped lang="scss">
.descBtn {
    padding: 0 20px 0 20px;
    color: #4d6fff;
    font-weight: 400;
}
.team_card_right {
    float: right;
    margin-right: 10px;
    line-height: 25px;
    color: #4d6fff;
}
.descBtnone {
    margin-left: 20px;
}
.team_card_header {
    background: linear-gradient(90deg, #e4ebf8 0%, #f3f6fc 100%);
}
.myteam_info {
    display: flex;
    flex-flow: row nowrap;
}
.myteam_info_img {
    width: 100px;
    padding: 20px;
    margin-right: 20px;
    .team_img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }
}
.inviteWay {
    margin-top: 30px;
}
.invite_card {
    display: flex;
    flex-flow: row nowrap;
    height: 150px;
    border-radius: 7px;
    background: #ebf1ff;
    margin: 20px 0;
    padding: 10px 25px;
}
.invite_card_left {
    width: 75%;
}
.invite_right_button {
    cursor: pointer;
    padding: 0 5px;
    height: 20px;
    line-height: 20px;
    background: #c1cdff;
    font-size: 12px;
    color: #4d6fff;
    text-align: center;
    margin-top: 10px;
    border-radius: 3px;
}
.invite_card_right {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 25%;
    img {
        width: 50%;
    }
}
.invite_title {
    margin: 20px 0;
}
.inviteLink {
    width: 95%;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.codeBox {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around;
}
.descItem {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
}
.apply {
    width: 300px;
    font-size: 12px;
    position: absolute;
    color: #999999;
    top: 23px;
    left: -120px;
}
</style>
